module.exports = __webpack_public_path__ + "static/media/intro_icon_7.955b32f6.svg";